(function( $, root ){

    let $hidden_permalink,
        $copy_link_button,
        debounce;

    function store_dom_references () {
        $hidden_permalink = $( '.hidden-permalink' );
        $copy_link_button = $( '.copy-link-button' );
    }

    function fade_to_new_content ( $element, content ) {
        $element.fadeOut( 250, function () {
            $element.html( content );
            $element.fadeIn( 250 );
        });
    }

    $(function () {
        store_dom_references();

        $copy_link_button.click( function() {
            clearTimeout( debounce );
            let $this = $(this);
            let $temp_element = $( '<input>' );
            $( 'body' ).append( $temp_element );
            $temp_element.val( $hidden_permalink.val() ).select();
            document.execCommand( 'copy' );
            $temp_element.remove();
            fade_to_new_content( $this, 'Link Copied!' );
            debounce = setTimeout( function () {
                fade_to_new_content( $this, 'Copy Link' );
            }, 2500 );
        } );
    });

})(jQuery, this);